import { Button, Element, Icon } from '@zmedia/bm-soccer-ui/components';
import cn from 'classnames';
import { Dispatch, SetStateAction, memo, useRef, useState } from 'react';
import { useOutsideClick } from '@zmedia/bm-soccer-ui/hooks';
import styles from './style.module.scss';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';

interface IGroup {
    id: number;
    name: string;
}

export function SelectGroup({
    groups = [],
    groupId,
    groupName,
    selectGroup,
}: {
    groups: IGroup[];
    groupId: number;
    groupName: string;
    selectGroup: Dispatch<SetStateAction<IGroup>>;
}) {
    const [open, toggleOpen] = useState<boolean>(false);
    const selectRef = useRef(null);

    const handleClickOutside = (isInside: boolean) => {
        if (!isInside) {
            setTimeout(() => toggleOpen(false), 100);
        }
    };

    useOutsideClick(selectRef, handleClickOutside);

    const renderGroup = (item: IGroup, index: number) => {
        return (
            <Element
                className={cn(styles['group-item'], {
                    [styles['is-select']]: item.id === groupId,
                })}
                key={index}
                onClick={() => selectGroup(item)}
            >
                <Element className={styles['select-text']}>{item.name}</Element>
            </Element>
        );
    };

    const renderGroups = (groups: IGroup[]) => {
        return groups.map((group: IGroup, index: number) => {
            return renderGroup(group, index);
        });
    };

    if (ArrayUtils.isEmpty(groups)) {
        return null;
    }

    return (
        <Element className={styles['select-group']}>
            <Button
                className={styles['btn-select']}
                onClick={() => toggleOpen(!open)}
                domRef={selectRef}
            >
                {groupName}
                {groups.length > 0 && <Icon icon={open ? 'up' : 'down'}></Icon>}
            </Button>

            {open && groups.length > 0 && (
                <Element className={styles['group-items']}>
                    {renderGroups(groups)}
                </Element>
            )}
        </Element>
    );
}

export default memo(SelectGroup);
